import React from 'react';
export function Section({
  id,
  children,
  className
}: {
  id?: string;
  children: React.ReactNode;
  className?: string;
}) {
  return <section id={id} className={`scroll-mt-24 border-t border-line/60 py-16 md:py-24 ${className ?? ''}`} data-id="element-593" data-mp="2i77fsyml5di5">
      <div className="mx-auto w-full max-w-7xl px-5 md:px-8" data-id="element-594" data-mp="2vylvavhaawkg">{children}</div>
    </section>;
}
export function SectionHeading({
  title,
  lead,
  align = 'left',
  action
}: {
  title: string;
  lead?: string;
  align?: 'left' | 'center';
  action?: React.ReactNode;
}) {
  const centered = align === 'center';
  return <div className={`mb-10 flex flex-col gap-5 md:mb-12 ${centered ? 'items-center text-center' : 'md:flex-row md:items-end md:justify-between'}`} data-id="element-595" data-mp="3ew5akguc5bfb">
      <div className={centered ? 'max-w-2xl' : 'max-w-2xl'} data-id="element-596" data-mp="1khce6flmogmb">
        <h2 className="text-3xl font-extrabold leading-[1.1] tracking-tight text-white md:text-[42px]" data-id="element-597" data-mp="1kjovcqjkamyb">
          {title}
        </h2>
        {lead ? <p className="mt-3 text-base leading-relaxed text-mist md:text-lg" data-id="element-598" data-mp="24m1ea3oh6vfp">{lead}</p> : null}
      </div>
      {action ? <div className="shrink-0" data-id="element-599" data-mp="29kw4hqorvm9u">{action}</div> : null}
    </div>;
}